/**
 * Superficie pública del bounded context Customer (mobile).
 * Re-exporta desde domain-api, infra-api, app-api + UI directa (components/screens).
 * Tipos: [`domain/customerTypes`](./domain/customerTypes.ts). Implementación: [`infra/customerRepository`](./infra/customerRepository.ts).
 */
// Side-effect import movido a src/init/sessionResetRegistrations.ts (cargado en App.tsx).
// Antes acá: import './infra/sessionResetRegistration' — forzaba evaluación sincrónica
// del barrel y convertía require cycles en crashes de runtime.

export * from './domain-api';
export * from './infra-api';
export * from './app-api';

// UI — se mantiene directo en public-api
export { CustomerMovementHistoryModal } from './components/CustomerMovementHistoryModal';
export { CustomerDetailModal } from './components/CustomerDetailModal';
export { CustomerCard } from './components/CustomerCard';
export { CustomerMovementModal } from './components/CustomerMovementModal';
export { CustomerEditorModal } from './components/CustomerEditorModal';
export { CustomersScreenHeader } from './components/CustomersScreenHeader';
export {
  CustomerSearchField,
  type CustomerSearchSelection,
} from './components/CustomerSearchField';

export { CustomersScreen } from './screens/CustomersScreen';
export { FollowUpInboxScreen } from './screens/FollowUpInboxScreen';
